import { Link } from "react-router-dom";
import { heroStats } from "@/mocks/categories";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[640px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20illustration%20of%20overlapping%20speech%20bubbles%20and%20spotlight%20beams%20forming%20a%20crowd%20silhouette%2C%20deep%20warm%20terracotta%20red%20and%20amber%20glow%2C%20moody%20gradient%20background%2C%20geometric%20shapes%2C%20no%20text%2C%20no%20faces&width=1600&height=900&seq=guayouhui-hero-main&orientation=landscape"
        alt="瓜友会网吃瓜现场氛围背景图"
        title="瓜友会网 · 吃瓜现场"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-primary-950/80"></div>

      <div className="relative z-10 w-full px-4 md:px-8 py-16 md:py-24 flex flex-col items-center text-center">
        <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/25 text-background-50 text-xs md:text-sm backdrop-blur-sm">
          <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
          吃瓜现场 · 一手热瓜实时更新
        </span>

        <h1 className="mt-6 text-background-50 font-bold tracking-tight">
          <span className="block text-sm md:text-base tracking-[0.4em] text-accent-300 mb-3">
            瓜友会网
          </span>
          <span className="block text-3xl sm:text-4xl md:text-6xl leading-tight">
            点开即刻进入吃瓜现场
          </span>
        </h1>

        <p className="mt-5 max-w-2xl text-sm md:text-lg text-background-100/85 leading-relaxed">
          今日爆料、热门瓜田、新鲜瓜实时滚动。从娱乐圈到网红圈，蹲最新进展、看网友热评，
          你想知道的都在这里。
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto">
          <a
            href="#live-feed"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 h-12 px-7 rounded-full bg-primary-500 text-background-50 text-sm md:text-base whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-fire-line text-lg" aria-hidden="true"></i>
            进入今日热榜
          </a>
          <Link
            to="/about#submit"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 h-12 px-7 rounded-full bg-background-50/10 border border-background-50/30 text-background-50 text-sm md:text-base whitespace-nowrap backdrop-blur-sm hover:bg-background-50/20 transition-colors cursor-pointer"
          >
            <i className="ri-megaphone-line text-lg" aria-hidden="true"></i>
            我要爆料
          </Link>
        </div>

        <dl className="mt-12 md:mt-16 w-full max-w-3xl grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {heroStats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg bg-background-50/10 border border-background-50/20 backdrop-blur-sm px-3 py-4"
            >
              <dt className="text-[11px] md:text-xs text-background-100/70">
                {stat.label}
              </dt>
              <dd className="mt-1 text-xl md:text-2xl font-bold text-accent-300">
                {stat.value}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}